import { Globe, Heart } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  const cities = [
    { name: "Madrid", id: "madrid" },
    { name: "Barcelona", id: "barcelona" },
    { name: "Ciudad de México", id: "ciudad-de-mexico" },
    { name: "Buenos Aires", id: "buenos-aires" },
    { name: "Bogotá", id: "bogota" },
  ];

  return (
    <footer className="footer" data-testid="footer">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center">
                <Globe className="w-5 h-5 text-white" />
              </div>
              <span className="font-heading font-bold text-xl text-white tracking-tight">
                Intercambios<span className="text-primary">DeIdioma</span>
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Tu directorio de intercambios de idiomas en ciudades de habla hispana. 
              Conecta con personas de todo el mundo y mejora tus habilidades lingüísticas.
            </p>
            <a 
              href="https://www.languageexchanges.com"
              className="inline-flex items-center gap-2 mt-3 text-sm text-primary hover:text-primary/80 transition-colors"
            >
              Eventos en Lingua2 Language Exchange
            </a>
          </div>

          {/* Popular Cities */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4">
              Ciudades Populares
            </h3>
            <ul className="space-y-2">
              {cities.map((city) => (
                <li key={city.id}>
                  <Link 
                    to={`/ciudad/${city.id}`}
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    {city.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-heading font-semibold text-white mb-4">
              Recursos
            </h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="#" 
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Guía para Principiantes
                </a>
              </li>
              <li>
                <a 
                  href="#" 
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Consejos de Aprendizaje
                </a>
              </li>
              <li>
                <a 
                  href="#" 
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Blog
                </a>
              </li>
              <li>
                <a 
                  href="#" 
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Contacto
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} IntercambiosDeIdioma. Todos los derechos reservados.
            </p>
            <p className="text-sm text-gray-500 flex items-center gap-1">
              Hecho con <Heart className="w-4 h-4 text-accent fill-accent" /> para la comunidad global
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
